"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var RightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.3 5.3a1 1 0 011.4 0l6 6a1 1 0 010 1.4l-6 6a1 1 0 01-1.4-1.4l5.29-5.3-5.3-5.3a1 1 0 010-1.4z" } }] }, "name": "right", "theme": "outlined" };
exports.default = RightOutlined;
